import script from "./FullscreenAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./FullscreenAlert.vue?vue&type=script&setup=true&lang=js"

import "./FullscreenAlert.vue?vue&type=style&index=0&id=02b57ae4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02b57ae4"]])

export default __exports__